import { useEffect } from 'react';
import { useAuthStore } from '../../../application/store/AuthStore';
import { useAuth } from '../../hooks/useAuth';

declare global {
    interface Window {
        tidioChatApi?: {
            setVisitorData: (data: Record<string, string>) => void;
            hide: () => void;
            show: () => void;
            open?: () => void;
        };
    }
}

export const TidioChat = () => {
    const { user, company } = useAuth();

    useEffect(() => {
        // Wait for Tidio to load
        const waitForTidio = setInterval(() => {
            if (window.tidioChatApi) {
                clearInterval(waitForTidio);

                // Set visitor data when user is authenticated
                if (user && company) {
                    window.tidioChatApi.setVisitorData({
                        distinct_id: user.id,
                        name: user.name,
                        email: user.email,
                    });
                }
            }
        }, 100);

        // Cleanup interval on unmount
        return () => {
            clearInterval(waitForTidio);
        };
    }, [user, company]);

    return null;
}; 